import Nullstack from 'nullstack';
export default function IconRulerOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ruler-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h11a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-4m-3.713 .299a0.997 .997 0 0 0 -.287 .701v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14c0 -.284 .118 -.54 .308 -.722"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h2"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h3"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h2"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v3"
  }), "   ", Nullstack.element("path", {
    d: "M16 4v2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}